export const PREFIX = 'referral';
//# sourceMappingURL=referral.js.map